import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";

let interval: number | null = null;
const FRAME_INTERVAL = 10;

const ad_url = process.env.REACT_APP_SPONSORED_AD_URL || "";

const TopAd = () => {
  const [showAd, setShowAd] = useState(false);
  const [adCount, setAdCount] = useState(0);
  const [assets, setAssets] = useState<any[]>([]);

  useEffect(() => {
    if (ad_url) {
      fetch(ad_url)
        .then((res) => res.json())
        .then(({ assets }) => {
          setAssets([...assets]);
        })
        .catch(err => {
          console.warn(err);
          setShowAd(false);
          setAssets([])
        })
    }
  }, []);

  useEffect(() => {
    if (interval) clearTimeout(interval);
    if (assets.length) {
      interval = window.setInterval(() => {
        setShowAd((prevState) => !prevState);
      }, FRAME_INTERVAL * 1000);
    }

    return () => {
      if (interval) clearTimeout(interval);
    };
  }, [assets]);

  const handleOnExited = () => {
    setAdCount(Math.floor(Math.random() * assets.length));
  };

  if (!assets.length) return null;

  return (
    <CSSTransition
      unmountOnExit
      in={showAd}
      classNames="ad"
      timeout={2000}
      onExited={handleOnExited}
    >
      <a
        href={assets[adCount].url}
        target="_blank"
        rel="noreferrer"
        className="mvc-ad-wrapper"
        onClick={(evt) => evt.stopPropagation()}
      >
        <img
          src={`https://nftworld.io/mbe/decentraland/ads/${assets[adCount].image}`}
          alt="advertise"
          height="60"
        />
      </a>
    </CSSTransition>
  );
};

export default TopAd;
